import { EventDispatcher } from 'three';
import { NOTIFICATION_EVENTS } from '../../constants/notifications';
import { ROOMS_EVENTS } from '../../constants/rooms';
import CustomSelect from '../engine/helpers/customSelect';

export default class RoomsModel extends EventDispatcher {
    constructor() {
        super();
        this.customSelect = new CustomSelect();
        this.urls = {
            search: $("#search-link").val()
        }
        this.url = new URL(window.location.href);

        this.eventListeners();
    }

    eventListeners = () => {
        let filterChangeDebounce
        let callRegistration = false
        this.addEventListener(ROOMS_EVENTS.ROOMS_FILTER_CHANGED, (e) => {
            const fetchData = () => {
                const search = $("#search-room").val();
                const sortBy = $("#space-sort-input").val();
                const order = $("#space-sort-order-input").val();
                const lang = $("#space-language-filter").val();
                const hasChessGame = $("#space-has-chess-filter").is(':checked') ? '1' : null;

                this.updateURL({
                    search,
                    sort: sortBy,
                    order,
                    lang,
                    hasChessGame,
                });

                this.filterRooms();
            }

            // This code will ensure that the filter change is not triggered multiple times
            if (!filterChangeDebounce) {
                fetchData();

                filterChangeDebounce = setTimeout(() => {
                    filterChangeDebounce = null

                    if (callRegistration) {
                        fetchData()
                    }
                    callRegistration = false
                }, 500);
            } else {
                callRegistration = true
            }
        });

        this.addEventListener(ROOMS_EVENTS.ROOMS_PAGING_CHANGED, (e) => {
            const fetchData = async () => {
                // Add loading state
                $('.rooms-container__load-more').hide();
                try {
                    await this.filterRooms({ isLoadingMore: true, page: e.data.page || 1 });
                } finally {
                    // Remove loading state
                    $('.rooms-container__load-more').show();
                }
            }

            // This code will ensure that the filter change is not triggered multiple times
            if (!filterChangeDebounce) {
                fetchData();

                filterChangeDebounce = setTimeout(() => {
                    filterChangeDebounce = null

                    if (callRegistration) {
                        fetchData()
                    }
                    callRegistration = false
                }, 500);
            } else {
                callRegistration = true
            }
        });

        window.addEventListener("popstate", (event) => {
            // fetch data from url
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('search')) {
                $("#search-room").val(urlParams.get('search'));
            } else {
                $("#search-room").val('');
            }
            if (urlParams.has('sort')) {
                $("#space-sort-input").val(urlParams.get('sort')).trigger('change');
            } else {
                $("#space-sort-input").val('active_users').trigger('change');
            }
            if (urlParams.has('order')) {
                $("#space-sort-order-input").val(urlParams.get('order')).trigger('change');
            } else {
                $("#space-sort-order-input").val('desc').trigger('change');
            }
            if (urlParams.has('lang')) {
                $("#space-language-filter").val(urlParams.get('lang'));
            } else {
                $("#space-language-filter").val('');
            }
            if (urlParams.has('hasChessGame')) {
                $("#space-has-chess-filter").prop('checked', true).trigger('change');
            } else {
                $("#space-has-chess-filter").prop('checked', false).trigger('change');
            }

            this.filterRooms();
        });
    }

    updateURL = (param, value) => {
        const urlParams = new URLSearchParams(window.location.search);

        let params = {};
        if (typeof param === 'string') {
            params[param] = value;
        } else {
            params = param;
        }

        Object.entries(params).forEach(([key, value]) => {
            switch (key) {
                case 'page':
                    if (value === 1) value = null;
                    break;
                case 'sort':
                    if (value === 'active_users' && params['order'] === 'desc') value = null;
                    break;
                case 'order':
                    if (value === 'desc' && params['sort'] === 'active_users') value = null;
                    break;
            }
            if (value) {
                this.url.searchParams.set(key, value);
            } else {
                urlParams.has(key) && this.url.searchParams.delete(key);
            }
        });

        // Check if the new URL is different from the current one before pushing state
        const newUrl = this.url.pathname + this.url.search;
        const currentUrl = window.location.pathname + window.location.search;

        if (newUrl !== currentUrl) {
            window.history.pushState("", "", newUrl);
        }
    }

    filterRooms = async ({ isLoadingMore = false, page = 1 } = {}) => {
        const search = $("#search-room").val();
        const sortBy = $("#space-sort-input").val();
        const orderBy = $("#space-sort-order-input").val();

        const lang = $("#space-language-filter").val();
        const hasChessGame = $("#space-has-chess-filter").is(':checked') ? 1 : null;

        let userLat = null;
        let userLng = null;

        let grantRequest = true;

        if (sortBy === 'distance') {
            try {
                const obj = await this.getCoords();

                if (obj.error) {
                    grantRequest = false;

                    if (obj.error.state === 'denied') {
                        this.alert("error", "Please grant access to geolocation");
                        $("#space-sort-popup .sort-option").first().trigger("click");
                    }
                }

                userLat = obj.lat;
                userLng = obj.lng;
            } catch (e) {
                console.error('Error when getting coordinates', e)
                if (e.code === 1) {
                    this.alert("error", "Please grant access to geolocation");
                    $("#space-sort-popup .sort-option").first().trigger("click");
                }
            }
        }

        if (grantRequest) {
            if (!$(".rooms-container__loading").length) {
                $("[data-card-container]").append("<div class='col-48 flex-center rooms-container__loading'><img src='/textures/gradient_loader.png' class='gradient-loader'></div>");
            }

            const param = $.param({ page })
            try {
                await $.post(`${this.urls.search}?${param}`, { search, sortBy, orderBy, userLat, userLng, lang, hasChessGame }, (roomCards) => {
                    $('.rooms-container__load-more').remove();

                    if (roomCards.dataProvider) {
                        if (isLoadingMore) {
                            $(`[data-card-container="dataProvider"]`).append(roomCards.dataProvider);
                        } else {
                            $(`[data-card-container="dataProvider"]`).html(roomCards.dataProvider);
                        }
                    }
                    if (roomCards.contProvider) {
                        if (isLoadingMore) {
                            $(`[data-card-container="contProvider"]`).append(roomCards.contProvider);
                        } else {
                            $(`[data-card-container="contProvider"]`).html(roomCards.contProvider);
                        }
                    }
                    if (!roomCards.dataProvider && !roomCards.contProvider) {
                        if (isLoadingMore) {
                            $("[data-card-container]").append(roomCards);
                        } else {
                            $("[data-card-container]").html(roomCards);
                        }
                    }
                });
            } finally {
                $('.rooms-container__loading').remove();
            }
        }
    }

    getCoords = async () => {
        let lat, lng, error = false;
        const result = await navigator.permissions.query({ name: 'geolocation' });

        switch (result.state) {
            case 'granted':
            case 'prompt':
                const pos = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                });
                lat = pos.coords.latitude;
                lng = pos.coords.longitude;
                break;
            case 'denied':
                error = { 'state': result.state };
                break;
            default:
                console.log('geolocation state: ', result.state);
                error = { 'state': result.state };
        }

        return {
            lat, lng, error
        };
    };

    /**
     * NOTIFICATIONS SYSTEM
     */

    alert = (classType, text, obj = {}) => {
        const data = { ...obj, classType, text }
        this.dispatchEvent({ type: NOTIFICATION_EVENTS.ALERT, data });
    }

    info = (classType, text, obj = {}) => {
        const data = { ...obj, classType, text }
        console.log('data', data);
        this.dispatchEvent({ type: NOTIFICATION_EVENTS.INFO, data });
    }

    confirm = (message, success = null, obj = {}, onCancel = null) => {
        const data = { ...obj, message, success, onCancel }
        this.dispatchEvent({ type: NOTIFICATION_EVENTS.CONFIRM, data });
    }

    prompt = (message, initialValue, success = null, obj = {}) => {
        const data = { ...obj, message, initialValue, success }
        this.dispatchEvent({ type: NOTIFICATION_EVENTS.PROMPT, data });
    }
}
